import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'simple-fullwidth-2-page-scroll',
    templateUrl  : './fullwidth-2.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SimpleFullwidth2PageScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
